//  ----------      START   IMPORT  BLOCK       ----------
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
//  Icons
import femaleSymbol from '../../../../../Assets/Icons/Sex/Gender-Symbol_Female.png';
import maleSymbol from '../../../../../Assets/Icons/Sex/Gender-Symbol_Male.png';
import transFemaleSymbol from '../../../../../Assets/Icons/Sex/Gender-Symbol_Trans_Female.png';
import transMaleSymbol from '../../../../../Assets/Icons/Sex/Gender-Symbol_Trans_Male.png';
//  Context
import { useLanguage } from '../../../../../API/Context/LanguageContext';
import { useActivePatient } from '../../../../../API/Hooks/ActivePatientContext';
//  Config
import VocabSexes from '../../../../../ConfigFiles/multilingual/VocabSexes';
import { SexEnum } from '../../../../../Types/Enums/SexEnum';
import './SexDisplay.css';
//  ----------      END   IMPORT  BLOCK       ----------

const SexDisplay: React.FC = () => {
  const { lan } = useLanguage();
  const { activePatient } = useActivePatient();

  const patient = activePatient?.patient;

  // Clean, modern extraction
  const sexAtBirth = patient?.biological_sex ?? null;
  const currentSex = patient?.current_sex ?? sexAtBirth;

  // Return null immediately if no valid sex data exists
  if (sexAtBirth === null) return null;

  const isCisgender = sexAtBirth === currentSex;
  const isFemale = (isCisgender ? sexAtBirth : currentSex) === SexEnum.FEMALE;

  // Select icon and tooltip directly without needing useEffect
  const sexIcon = isCisgender
    ? (isFemale ? femaleSymbol : maleSymbol)
    : (isFemale ? transFemaleSymbol : transMaleSymbol);

  const tooltipText = isCisgender
    ? (isFemale ? VocabSexes.female[lan] : VocabSexes.male[lan])
    : (isFemale ? VocabSexes.trans_female[lan] : VocabSexes.trans_male[lan]);

  return (
    <OverlayTrigger
      placement="top"
      overlay={({ placement, ...props }) => (
        <Tooltip id="sex-tooltip" {...props}>
          {tooltipText}
        </Tooltip>
      )}
    >
      <img src={sexIcon} alt={tooltipText} className="sex-icon" />
    </OverlayTrigger>
  );
};

export default SexDisplay;